/* Location pre-order. Every [data-cg-preorder] list on the page names variants that are out of
   stock at Cheeky HQ for this shopper's country. When a product form has one of them selected, its
   add button reads "Pre-order now" and a note shows under it. Themes and apps rewrite the button on
   variant change, so this re-applies after any DOM change. */
(function () {
  var cfg = window.cgPreorder || {};
  var LABEL = cfg.label || 'Pre-order';
  var ids = {};
  var queued = false;

  function collect() {
    document.querySelectorAll('script[data-cg-preorder]').forEach(function (s) {
      if (s.dataset.cgRead) return;
      s.dataset.cgRead = '1';
      try { JSON.parse(s.textContent).forEach(function (id) { ids[String(id)] = true; }); } catch (e) {}
    });
  }

  function labelNode(btn) {
    return btn.querySelector('[data-vso-atc-text]') || btn.querySelector('.button__content') || btn;
  }

  function setButton(btn, pre) {
    var node = labelNode(btn);
    var text = node.textContent.trim();
    if (pre && !btn.disabled) {
      if (text !== LABEL) {
        btn.dataset.cgOrig = text;
        node.textContent = LABEL;
        var rot = btn.querySelector('[rotated-text],[up-text]');
        if (rot) { rot.setAttribute(rot.hasAttribute('rotated-text') ? 'rotated-text' : 'up-text', LABEL); }
      }
      if (btn.hasAttribute('data-vso-add-text') && btn.getAttribute('data-vso-add-text') !== LABEL) {
        btn.dataset.cgOrigAdd = btn.getAttribute('data-vso-add-text');
        btn.setAttribute('data-vso-add-text', LABEL);
      }
    } else {
      if (text === LABEL && btn.dataset.cgOrig) node.textContent = btn.dataset.cgOrig;
      if (btn.dataset.cgOrigAdd) { btn.setAttribute('data-vso-add-text', btn.dataset.cgOrigAdd); delete btn.dataset.cgOrigAdd; }
    }
  }

  // Product pages with the "Best value" strip carry the note there instead of under the button
  function setStrip(form, pre) {
    if (!form.classList.contains('vso-product-info__form')) return false;
    var sec = form.closest('.shopify-section');
    var strip = sec && sec.querySelector('.cgpp-note > span');
    if (!strip) return false;
    if (pre && cfg.note) {
      if (!strip.dataset.cgPre) {
        strip.dataset.cgOrigHtml = strip.innerHTML;
        strip.dataset.cgPre = '1';
        strip.textContent = cfg.note;
      }
    } else if (strip.dataset.cgPre) {
      strip.innerHTML = strip.dataset.cgOrigHtml;
      delete strip.dataset.cgPre;
    }
    return true;
  }

  function setNote(form, btn, pre) {
    if (setStrip(form, pre)) return;
    var note = form.querySelector('.cg-preorder-note');
    if (!pre) { if (note) note.hidden = true; return; }
    if (!cfg.note || form.closest('.product-card')) return;
    if (!note) {
      note = document.createElement('p');
      note.className = 'cg-preorder-note';
      note.textContent = cfg.note;
      var anchor = btn.closest('.vso-product-info__actions, buy-buttons') || btn;
      anchor.parentNode.insertBefore(note, anchor.nextSibling);
    }
    note.hidden = false;
  }

  function apply() {
    queued = false;
    collect();
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var input = form.querySelector('input[name="id"], select[name="id"]');
      if (!input) return;
      var pre = !!ids[String(input.value)];
      var btns = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"], button[name="add"]'));
      if (form.id) {
        document.querySelectorAll('button[type="submit"][form="' + form.id + '"]').forEach(function (b) {
          if (btns.indexOf(b) === -1) btns.push(b);
        });
      }
      btns.forEach(function (b) { setButton(b, pre); });
      if (btns.length) setNote(form, btns[0], pre);
      form.toggleAttribute('data-cg-preorder-active', pre);
    });
    // Sticky bars that copy the main button's label
    var main = document.querySelector('form[data-cg-preorder-active] [data-vso-atc]');
    document.querySelectorAll('.cgpp-sticky__add').forEach(function (b) {
      setButton(b, !!main);
    });
    // "Ships tomorrow" estimates are wrong for a pre-order
    document.querySelectorAll('[data-cgpp-ship]').forEach(function (el) {
      var sec = el.closest('.shopify-section');
      el.style.display = sec && sec.querySelector('form[data-cg-preorder-active]') ? 'none' : '';
    });
  }

  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(apply, 30);
  }

  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  document.addEventListener('change', queue);
  document.addEventListener('variant:change', queue);
  // Variant id inputs are often set by script with no event
  setInterval(queue, 500);
  queue();
})();
